import type { VehicleType } from 'types/api.generated';

export type TrackingVehicleType = VehicleType | 'car';

const ICON_BY_TYPE: Record<TrackingVehicleType, string> = {
  bike: 'two_wheeler',
  tricycle: 'rickshaw',
  car: 'directions_car',
  van: 'airport_shuttle',
  truck: 'local_shipping',
};

/** Degrees to align icon with simple-route SVG line (bottom-left → top-right). */
export const SIMPLE_ROUTE_SCREEN_BEARING =
  (Math.atan2(360 - 40, -(40 - 160)) * 180) / Math.PI;

/** Compact map marker (w-10 was too large for small GPS steps). */
export const MAP_MARKER_INNER = 'w-7 h-7';
export const MAP_MARKER_ICON = 'text-[15px]';
export const ROUTE_MARKER_INNER = 'w-8 h-8';
export const ROUTE_MARKER_ICON = 'text-[17px]';

export function vehicleMarkerIcon(type: TrackingVehicleType | null | undefined): string {
  if (!type) return ICON_BY_TYPE.car;
  return ICON_BY_TYPE[type] ?? ICON_BY_TYPE.car;
}

export function resolveTrackingVehicleType(
  raw: string | null | undefined,
): TrackingVehicleType {
  const t = raw?.trim();
  if (
    t === 'bike' ||
    t === 'tricycle' ||
    t === 'car' ||
    t === 'van' ||
    t === 'truck'
  ) {
    return t;
  }
  return 'car';
}

export function formatDriverDisplayName(
  driver: { firstName: string; lastName?: string | null } | null | undefined,
): string | null {
  if (!driver?.firstName) return null;
  const last = driver.lastName?.trim();
  return last ? `${driver.firstName} ${last}` : driver.firstName;
}
